import _typeof from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * 通用混合
 * */
import { mapGetters } from 'vuex';
import columns from "@/pages/breed/cat/columns";
export default {
  data: function data() {
    return {
      initModifyData: {},
      customSearchColumns: []
    };
  },
  computed: _objectSpread(_objectSpread({
    data: function data() {
      return {
        api: null,
        _lastEndKey: ""
      };
    }
  }, mapGetters('admin/enum', ['enumList', 'enumLabel'])), {}, {
    searchColumns: function searchColumns() {
      var _this = this;
      var columns = [].concat(_toConsumableArray(this.table.columns), _toConsumableArray(this.customSearchColumns));
      var _columns = columns.filter(function (item) {
        return item.search;
      }).map(function (item) {
        var _obj = {
          label: item.title,
          name: item.key || item.slot,
          type: item.type,
          format: item.format,
          searchTooltip: item.searchTooltip,
          options: item.options,
          placeholder: item.placeholder
        };
        if (item.enum) {
          _obj.type = 'select';
          _obj.options = _this.enumList(item.enum);
        }
        return _obj;
      });
      return _columns;
    }
  }),
  mounted: function mounted() {
    this.initModifyData = this.$Utils.Tool.clone(this.modifyData);
  },
  methods: {
    // 当 $route 更新时触发
    appRouteChange: function appRouteChange(to, from) {},
    handleResetSearch: function handleResetSearch() {
      var _this2 = this;
      this.query.pageNo = 1;
      this.table.columns.forEach(function (item, index) {
        if (item.filters !== undefined) {
          _this2.$refs.table.handleFilterReset(index);
        }
      });
      this.$refs.queryForm && this.$refs.queryForm.resetFields();
      this.search();
    },
    handleDetail: function handleDetail(row) {
      this.handleModify(row, false);
    },
    modifyInit: function modifyInit(row) {
      var isEdit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.$refs.modifyForm && this.$refs.modifyForm.resetFields();
      if (this.$Utils.Json.isNotNull(row)) {
        this.modifyData = this.$Utils.Tool.clone(row);
      } else {
        this.modifyData = this.$Utils.Tool.clone(this.initModifyData);
      }
      this.modifyDrawer.isEdit = isEdit;
      this.modifyDrawer.show = true;
    },
    modifySave: function modifySave(params) {
      var _this3 = this;
      this.$refs.modifyForm.validate(function (valid) {
        if (valid) {
          _this3.modifyDrawer.loading = true;
          _this3.api.save(params).then(function () {
            _this3.modifyDrawer.show = false;
            _this3.$Utils.Toast.Message.success("操作成功！");
            _this3.reloadData();
          }).finally(function () {
            _this3.modifyDrawer.loading = false;
          });
        }
        // else {
        //     this.$Utils.Toast.Message.warning("请完善信息")
        // }
      });
    },
    examineInit: function examineInit(row) {
      this.examineData = row;
      this.examineModal.show = true;
    },
    examineSave: function examineSave(params) {
      var _this4 = this;
      this.examineModal.loading = true;
      this.api.examine(params).then(function () {
        _this4.examineModal.show = false;
        _this4.$Utils.Toast.Message.success("操作成功！");
        _this4.reloadData();
      }).finally(function () {
        _this4.examineModal.loading = false;
      });
    },
    handleActionBefore: function handleActionBefore() {
      var _this5 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var fn = arguments.length > 1 ? arguments[1] : undefined;
      var _params = _objectSpread({
        title: '温馨提示',
        content: '更改？'
      }, params);
      var _content = "\u60A8\u786E\u5B9A\u8981<span class=\"ivu-btn-ghost ivu-btn-error\">".concat(_params.content, "</span>\u5417\uFF1F");
      if (fn) {
        return function () {
          return new Promise(function (resolve) {
            if (_params.confirm) {
              _this5.$Modal.confirm({
                title: _params.title,
                content: _content,
                onOk: function onOk() {
                  fn && fn();
                }
              });
            } else {
              fn && fn();
            }
          });
        };
      } else {
        return new Promise(function (resolve) {
          _this5.$Modal.confirm({
            title: _params.title,
            content: _content,
            onOk: function onOk() {
              resolve();
            }
          });
        });
      }
    },
    handleUpdateValue: function handleUpdateValue(row) {
      var _this6 = this;
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'status';
      var content = arguments.length > 2 ? arguments[2] : undefined;
      var refresh = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var k = "".concat(row.id || row._index, "-").concat(key, "-").concat(String(content));
      if (k === this._lastEndKey) return;
      this._lastEndKey = k;
      this.$nextTick(function () {
        return _this6._lastEndKey = "";
      });
      var oValue = this.getByPath(row, key);
      if (content) {
        if (oValue == content) {
          return;
        }
      }
      var value = content;
      this.setByPath(row, key, value);
      this.update(row, key, value, refresh, oValue);
    },
    handleUpdate: function handleUpdate(row, tips) {
      var _this7 = this;
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'status';
      var refresh = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var confirmValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var _tip = Object.prototype.toString.call(tips) === '[object Array]' ? tips[0] : tips;
      var value = this.getByPath(row, key) ? 0 : 1;
      return this.handleActionBefore({
        content: "".concat(value === confirmValue ? _tip : tips[1]),
        confirm: value === confirmValue
      }, function () {
        return _this7.update(row, key, value, refresh);
      });
    },
    handleUpdate1: function handleUpdate1(row, tips) {
      var _this8 = this;
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'status';
      var refresh = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var confirmValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var _tip = Object.prototype.toString.call(tips) === '[object Array]' ? tips[0] : tips;
      var value = confirmValue;
      return this.handleActionBefore({
        content: "".concat(value === confirmValue ? _tip : tips[1]),
        confirm: value === confirmValue
      }, function () {
        return _this8.update(row, key, value, refresh);
      });
    },
    getByPath: function getByPath(obj, path) {
      var _path$split$reduce;
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return (_path$split$reduce = path.split(".").reduce(function (cur, k) {
        if (cur == null) return undefined;
        return cur[k];
      }, obj)) !== null && _path$split$reduce !== void 0 ? _path$split$reduce : defaultValue;
    },
    setByPath: function setByPath(obj, path, value) {
      var keys = path.split(".");
      var cur = obj;
      for (var i = 0; i < keys.length - 1; i++) {
        var k = keys[i];
        if (cur[k] == null || _typeof(cur[k]) !== "object") cur[k] = {};
        cur = cur[k];
      }
      cur[keys[keys.length - 1]] = value;
    },
    update: function update(row, key, value) {
      var _this9 = this;
      var refresh = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var oValue = arguments.length > 4 ? arguments[4] : undefined;
      var _params = {};
      _params[this.idName] = row[this.idName];
      // _params[key] = value
      this.setByPath(_params, key, value);
      var loadingKey = key.split(".").pop() + "Loading";
      row[loadingKey] = true;
      if (row) {
        row.loading = true;
      }
      this.api.update && this.api.update(_params).then(function () {
        if (refresh) {
          _this9.reloadData();
        } else {
          _this9.setByPath(row, key, value);
        }
        _this9.$Utils.Toast.Message.success("操作成功！");
      }).catch(function () {
        if (oValue) {
          _this9.setByPath(_params, key, oValue);
        } else {
          _this9.reloadData();
        }
      }).finally(function () {
        setTimeout(function () {
          row[loadingKey] = false;
          if (row) {
            row.loading = false;
          }
        }, 500);
      });
    },
    handleSwitchBefore: function handleSwitchBefore(row, tips) {
      var _this0 = this;
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'status';
      var _tip = Object.prototype.toString.call(tips) === '[object Array]' ? tips[0] : tips;
      return this.handleActionBefore({
        content: "".concat(this.getByPath(row, key) ? _tip : tips[1]),
        confirm: row[key]
      }, function () {
        return _this0.updateSwitchStatusBefore(row, key, _this0.getByPath(row, key) ? 0 : 1);
      });
    },
    updateSwitchStatusBefore: function updateSwitchStatusBefore(row, key, value) {
      var _params;
      if (row) {
        _params = {
          idList: [row[this.idName]]
        };
      } else {
        _params = {
          idList: this.selectNodesAttribute
        };
      }
      this.setByPath(_params, key, value);
      this.updateSwitchStatus(row, key, value, _params);
    },
    updateSwitchStatus: function updateSwitchStatus(row, key, status, params) {
      var _this1 = this;
      var _params = {};
      _params[this.idName] = row[this.idName];
      _params[key] = status;
      row[key + 'Loading'] = true;
      if (row) {
        row.loading = true;
      }
      this.api.updateAttribute(params || _params).then(function () {
        row[key] = status;
        _this1.$Utils.Toast.Message.success("操作成功！");
      }).finally(function () {
        setTimeout(function () {
          row[key + 'Loading'] = false;
          if (row) {
            row.loading = false;
          }
        }, 500);
      });
    },
    updateDelBefore: function updateDelBefore(row) {
      var idName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
      this.updateDel(row, {}, idName);
    },
    handleDel: function handleDel(row) {
      var _this10 = this;
      var idName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
      this.handleActionBefore({
        content: "\u5220\u9664"
      }).then(function () {
        return _this10.updateDelBefore(row, idName);
      });
    },
    updateDel: function updateDel(row, params) {
      var _this11 = this;
      var idName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
      var _params;
      if (row) {
        _params = {
          idList: [row[this.idName]]
        };
      } else {
        _params = {
          idList: this.selectNodesAttribute
        };
      }
      if (params) Object.assign(_params, params);
      this.selectionLoading = true;
      if (row) {
        row.loading = true;
      }
      this.api.del(_params).then(function () {
        _this11.$Utils.Toast.Message.success("操作成功！");
        _this11.handleClearSelectNode();
        _this11.reloadData();
      }).finally(function () {
        setTimeout(function () {
          _this11.selectionLoading = false;
          if (row) {
            row.loading = false;
          }
        }, 500);
      });
    },
    updateStatusMultiple: function updateStatusMultiple(statusValue) {
      var _this12 = this;
      var _params;
      var rows = this.getSelectNodes();
      if (!rows) {
        return;
      }
      rows.forEach(function (row) {
        row.loading = true;
      });
      _params = {
        idList: rows.map(function (item) {
          return item[_this12.idName];
        }),
        status: statusValue
      };
      this.selectionLoading = true;
      this.api.updateAttribute(_params).then(function () {
        _this12.$Utils.Toast.Message.success("操作成功！");
        _this12.handleClearSelectNode();
        _this12.reloadData();
      }).finally(function () {
        setTimeout(function () {
          _this12.selectionLoading = false;
          rows.forEach(function (row) {
            row.loading = false;
          });
        }, 500);
      });
    },
    removeMultiple: function removeMultiple() {
      var _this13 = this;
      this.handleActionBefore({
        content: "\u5220\u9664"
      }).then(function () {
        var _params;
        var rows = _this13.getSelectNodes();
        if (!rows) {
          return;
        }
        rows.forEach(function (row) {
          row.loading = true;
        });
        _params = {
          idList: rows.map(function (item) {
            return item[_this13.idName];
          })
        };
        _this13.selectionLoading = true;
        _this13.api.del(_params).then(function () {
          _this13.$Utils.Toast.Message.success("操作成功！");
          _this13.handleClearSelectNode();
          _this13.reloadData();
        }).finally(function () {
          setTimeout(function () {
            _this13.selectionLoading = false;
            rows.forEach(function (row) {
              row.loading = false;
            });
          }, 500);
        });
      });
    }
  }
};